import { render } from "./Welcome.vue?vue&type=template&id=baf54404&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=baf54404&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-baf54404"

export default script